// import React from "react";
// import styled from "styled-components";
// import { LineChart } from "@mui/x-charts";
// import Loader from "../common/Loader";

// export type TLineSeries = {
//   label: string;
//   data: number[];
//   color?: string;
// };

// type TGenericLineChart = {
//   data?: TLineSeries[];
//   xLabels?: string[];
//   height?: number;
//   yLabel?: string;
//   loading?: boolean;
// };

// export const GenericLineChart = ({
//   data,
//   xLabels,
//   height = 300,
//   yLabel = "Value",
//   loading = false,
// }: TGenericLineChart) => {
//   if (loading) {
//     return (
//       <LoaderWrapper>
//         <Loader />
//       </LoaderWrapper>
//     );
//   }

//   if (!data || data.length === 0 || !xLabels || xLabels.length === 0) {
//     return <NoDataWrapper>No Data to display</NoDataWrapper>;
//   }

//   return (
//     <LineChart
//       height={height}
//       xAxis={[
//         {
//           scaleType: "point",
//           data: xLabels,
//         },
//       ]}
//       yAxis={[
//         {
//           label: yLabel,
//           min: 0,
//           max: Math.max(...(data?.[0]?.data || [1])) * 1.2,
//           // showGrid: true,
//           // showTicks: true,
//         },
//       ]}
//       series={data.map((item) => ({
//         data: item.data,
//         label: item.label,
//         color: item.color,
//         curve: "monotoneX",
//       }))}
//       sx={{
//         "& .MuiChartsLegend-series tspan": { fontSize: "0.8em" },
//         "& .MuiChartsAxis-root": {
//           fontSize: "12px",
//           color: "#64748b",
//         },
//       }}
//     />
//   );
// };

// const NoDataWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: 220px;
//   font-size: 0.8em;
//   color: #64748b;
// `;

// const LoaderWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: 220px;
// `;

// export default GenericLineChart;
import React from "react";
import styled from "styled-components";
import { LineChart } from "@mui/x-charts";
import Loader from "../common/Loader";

export type TLineSeries = {
  label: string;
  data: number[];
  color?: string;
};

type TGenericLineChart = {
  data?: TLineSeries[];
  xLabels?: string[];
  height?: number;
  yLabel?: string;
  loading?: boolean;
};

export const GenericLineChart = ({
  data,
  xLabels,
  height = 300,
  yLabel = "Value",
  loading = false,
}: TGenericLineChart) => {
  if (loading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  if (!data || !xLabels || data.length === 0 || xLabels.length === 0) {
    return <NoDataWrapper>No Data to display</NoDataWrapper>;
  }

  return (
    <LineChart
      height={height}
      xAxis={[
        {
          scaleType: "point",
          data: xLabels,
        },
      ]}
      yAxis={[
        {
          label: yLabel,
          min: 0,
        },
      ]}
      series={data.map((item) => ({
        data: item.data,
        label: item.label,
        curve: "monotoneX",
        showMark: true,
      }))}
      grid={{ horizontal: true }}
      sx={{
        "& .MuiChartsLegend-series tspan": { fontSize: "0.8em" },
        "& .MuiChartsAxis-root": {
          fontSize: "12px",
          color: "#64748b",
        },
      }}
    />
  );
};

const NoDataWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 220px;
  font-size: 0.8em;
  color: #64748b;
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 220px;
`;

export default GenericLineChart;
